import { render, staticRenderFns } from "./TambahAdvokasi.vue?vue&type=template&id=9c69c48e"
import script from "./TambahAdvokasi.vue?vue&type=script&lang=js"
export * from "./TambahAdvokasi.vue?vue&type=script&lang=js"
import style0 from "./TambahAdvokasi.vue?vue&type=style&index=0&id=9c69c48e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports